<template>
  <l-dialog
    :show="show"
    :isbtn="false"
    :ischa="true"
    @cancel="close()"
    class="teamMHT"
    :title="scaleInfo.title"
  >
    <div class="tBox">
      <div
        ref="bar"
        id="bar"
        v-show="false"
        style="height:300px; width: 500px;"
      ></div>
      <div class="left" ref="minBox">
        <h3>一、心理体检概况</h3>
        <p>本报告为心理健康评估结果分析，选用中小学生心理健康诊断测验(MHT)，
          从八个方面全方位的对心理健康进行筛查。根据测评结果数据，
          将测试者的心理健康状态划分为三个水平，即：较高、中等、较低。</p>

        <h4>1.1 心理体检人员基本信息</h4>
        <p>参加此次心理体检的人员共{{jcxx.sum}}人，其中男性{{jcxx.sex_nan}}人，女性{{jcxx.sex_nv}}人。
          年龄区间为{{jcxx.age_qj}}岁，平均年龄为{{jcxx.age_ave}}岁，标准差为{{jcxx.age_bzc}}。</p>
        <table cellspacing="0">
          <tr>
            <td></td>
            <td>男</td>
            <td>女</td>
            <td>总数</td>
          </tr>
          <tr>
            <td>人数</td>
            <td>{{jcxx.sex_nan}}</td>
            <td>{{jcxx.sex_nv}}</td>
            <td>{{jcxx.sum}}</td>
          </tr>
          <tr>
            <td>百分比</td>
            <td>{{jcxx.sex_nan|percentage(jcxx.sum)}}</td>
            <td>{{jcxx.sex_nv|percentage(jcxx.sum)}}</td>
            <td>100%</td>
          </tr>
        </table>
        <img
          :src="jcxx.base64_sex"
          alt=""
        >

        <h4>1.2 心理测验简介 </h4>
        <p>中小学生心理健康诊断测验（MHT）是由华东师范大学心理学教授周步成和其他心理学科
          研人员根据日本铃木清等人编制的《中小学生不安倾向诊断测验》修订而成的，可用于综合检
          测中小学生的心理健康状况。量表在全国二十多个省市（除港、澳、台之外）几千所中小学得到了广泛使用，
          普遍认为符合测量学的要求，信度和效度高，科学性、实用性、操作性强，是全国较好的心理测量工具之一。
          本测验共有{{jcxx.testSum}}个项目，在这{{jcxx.testSum}}个项目中含有八个内容量表和一个效度量表（即测谎量表）。</p>
        <p>八个内容量表分别是：学习焦虑、对人焦虑、孤独倾向、自责倾向、过敏倾向、身体症状、恐怖倾向、冲动倾向等。
          每个项目后面有“是”和“否”两个答案，要求被试根据自己的真实情况进行选择。</p>
        <p>本测验的目的是帮助学生、家长和教师更好地了解学生的基本心理健康状况，量表提供了学生在八个主要方面的表现，
          教师和家长可据此，在教育的过程中及时地针对学生的情况加以帮助和辅导。学生可以通过对自身情况的了解，做出有针对性地自我提高。</p>

        <h3>二、心理健康评估数据分析报告 </h3>
        <h4>2.1 参试人员整体效度分布</h4>
        <p>根据个人测评数据结果提示，目前有{{jcxx.yxDataSum}}人测试结果有效，{{jcxx.wxDataSum}}人测试结果无效</p>
        <table cellspacing="0">
          <tr>
            <td></td>
            <td>测试结果有效</td>
            <td>测试结果无效</td>
          </tr>
          <tr>
            <td>人数</td>
            <td>{{jcxx.yxDataSum}}</td>
            <td>{{jcxx.wxDataSum}}</td>
          </tr>
          <tr>
            <td>百分比</td>
            <td>{{jcxx.yxDataSum|percentage(jcxx.yxDataSum+jcxx.wxDataSum)}}</td>
            <td>{{jcxx.wxDataSum|percentage(jcxx.yxDataSum+jcxx.wxDataSum)}}</td>
          </tr>
        </table>

        <h4>2.2 参试人员整体心理健康状况分布</h4>
        <p>根据个人测评数据结果提示，目前有{{jcxx.jkDataSum}}人处于心理健康水平，{{jcxx.bjkDataSum}}人的心理体检数据显示有心理问题倾向</p>
        <table cellspacing="0">
          <tr>
            <td></td>
            <td>健康</td>
            <td>欠佳</td>
            <td>不健康</td>
          </tr>
          <tr>
            <td>人数</td>
            <td>{{jcxx.jkDataSum}}</td>
            <td>{{jcxx.qqDataSum}}</td>
            <td>{{jcxx.bjkDataSum}}</td>
          </tr>
          <tr>
            <td>百分比</td>
            <td>{{jcxx.jkDataSum|percentage(jcxx.jkDataSum+jcxx.qqDataSum+jcxx.bjkDataSum)}}</td>
            <td>{{jcxx.qqDataSum|percentage(jcxx.jkDataSum+jcxx.qqDataSum+jcxx.bjkDataSum)}}</td>
            <td>{{jcxx.bjkDataSum|percentage(jcxx.jkDataSum+jcxx.qqDataSum+jcxx.bjkDataSum)}}</td>
          </tr>
        </table>
        <img
          :src="jcxx.base64_jk"
          alt=""
        >

        <h4>2.3 参试人员各因子健康状况分布</h4>
        <p>表中列出参试人员MHT八因子较高、中等、较低的人数分布与百分比。
          图中画出八因子各状况人数分布，并较详细的描述各因子的症状表现</p>
        <table cellspacing="0">
          <tr>
            <td
              colspan="2"
              rowspan="2"
            >因子</td>
            <td colspan="2">较高</td>
            <td colspan="2">中等</td>
            <td colspan="2">较低</td>
          </tr>
          <tr>
            <td>人数</td>
            <td>百分比</td>
            <td>人数</td>
            <td>百分比</td>
            <td>人数</td>
            <td>百分比</td>
          </tr>
          <tr
            v-for="item of yzjkxxArr"
            :key="item.name"
          >
            <td colspan="2">{{ item.name }}</td>
            <td>{{item.data1}}</td>
            <td>{{item.data1|percentage(item.data1 + item.data2 + item.data3)}}</td>
            <td>{{item.data2}}</td>
            <td>{{item.data2|percentage(item.data1 + item.data2 + item.data3)}}</td>
            <td>{{item.data3}}</td>
            <td>{{item.data3|percentage(item.data1 + item.data2 + item.data3)}}</td>
          </tr>
        </table>

        <p>学习焦虑因子反应参试者是否每天把学习挂在心上，上课时是否担心被老师提问而心神不定，
          是否一有考试就怕考不好。 如下图中，测试结果显示：{{yzjkxx.data_1xx.data1}}位对考试常怀有强烈的焦虑和恐惧心理；
          {{yzjkxx.data_1xx.data2}}位对考试虽然怀有一定的恐惧和焦虑，但是并不影响受测者的正常学习和生活；{{yzjkxx.data_1xx.data3}}位学习不会受到困扰，能正确看待考试成绩。</p>
        <img
          :src="yzjkxx.data_1xx.base64"
          alt=""
        >

        <p>对人焦虑因子反映参试者是否不会与人交往，很怕生人；是否与他人讲话时，担心会不会脸红；
          受到老师或父母责备时，是否一直放在心上；是否担心朋友在背地里说自己的坏话，因而经常感到焦虑。
          如下图中，测试结果显示：{{yzjkxx.data_2sj.data1}}位过分注重自己在他人心目中的形象，对自己能否交到朋友没有信心；
          {{yzjkxx.data_2sj.data2}}位对人际关系有些敏感，有时会很在意自己在他人心目中的形象；{{yzjkxx.data_2sj.data3}}位待人热情、大方，主动与人交往，容易结交到新朋友。</p>
        <img
          :src="yzjkxx.data_2sj.base64"
          alt=""
        >

        <p>孤独倾向因子主要反映参测者是否经常因孤独而烦恼，感到和大家一起玩还不如一个人玩，
          不会和大家一起相处，只要是人们聚集在一起，就会感到恐怖。 如下图中，测试结果显示：
          {{yzjkxx.data_3gd.data1}}位他们喜欢独自一个人做事，经常独来独往；{{yzjkxx.data_3gd.data2}}位有时喜欢孤独的感受，但如果孤独的时间久了，
          又会去寻求与朋友相处；{{yzjkxx.data_3gd.data3}}位爱好社交，喜欢寻求刺激，乐于与他人在一起。</p>
        <img
          :src="yzjkxx.data_3gd.base64"
          alt=""
        >

        <p>自责倾向因子主要反映参测者是否发生不如意的事情时，不认为是他人的问题，
          而经常认为自己不好，对自己所做的事抱有恐惧倾向。 如下图中，测试结果显示：{{yzjkxx.data_4zz.data1}}位比较自卑，
          怀疑自己的能力；{{yzjkxx.data_4zz.data2}}位可以比较客观地评价自己，能够对失败和挫折进行合理的归因；{{yzjkxx.data_4zz.data3}}位有很强的自信心，能够乐观的认识自己的能力。</p>
        <img
          :src="yzjkxx.data_4zz.base64"
          alt=""
        >

        <p>过敏倾向因子主要测查参试者感受性太强，就连小事都放心不下，对周围的噪声特别敏感，
          担心家属中有人会受伤、生病或死亡，决定事情不果断，即使做了好事也感到烦恼。
          如下图中，测试结果显示：{{yzjkxx.data_5gm.data1}}位过于敏感，对日常生活事件敏感多疑；{{yzjkxx.data_5gm.data2}}位敏感性中等，对日常生活事件不会过分烦恼、
          担心；{{yzjkxx.data_5gm.data3}}位敏感性较低，能够对周围的日常事件或意外事件做出合理的解释和预测。</p>
        <img
          :src="yzjkxx.data_5gm.base64"
          alt=""
        >

        <p>身体症状因子主要测查参试者当焦虑急剧袭来时，是否感到将会死去，呼吸困难，
          心跳加快，感到喘不过气，出虚汗，头晕，知觉异常。如果焦虑是慢慢产生的，就会心神不定，
          心跳异常，脉博混乱，想呕吐，食欲不振，肚子痛或失眠等。 如下图中，测试结果显示：{{yzjkxx.data_6st.data1}}位身体出现了一些较严重的不适感；
          {{yzjkxx.data_6st.data2}}位较少时候会出现一些与心理紧张相关的身体的不适感；{{yzjkxx.data_6st.data3}}位基本没有由心理紧张、焦虑而引发的身体异常或者无意识的不良行为表现。</p>
        <img
          :src="yzjkxx.data_6st.base64"
          alt=""
        >

        <p>恐怖倾向因子主要测查参试者是否有恐惧心理。例如只要登上高处就怕得不能站立，无缘无故地恐惧黑暗，
          晚上开灯睡觉等。 如下图中，测试结果显示：{{yzjkxx.data_7kb.data1}}位让人感到非常胆小；
          {{yzjkxx.data_7kb.data2}}位一般不会对日常生活当中的常见情景感到特别地紧张害怕；{{yzjkxx.data_7kb.data3}}位胆量偏大。</p>
        <img
          :src="yzjkxx.data_7kb.base64"
          alt=""
        >

        <p>冲动倾向因子主要测查参试者是否有时无缘无故地想大声哭，大声叫或者一看到想要的东西，就一定要拿到手，
          毫无理由地想到远处去，或想死等。 如下图中，测试结果显示：{{yzjkxx.data_8cd.data1}}位做事十分冲动，比较缺乏理智的自我控制能力；
          {{yzjkxx.data_8cd.data2}}位有时具有冲动的表现，但通常还是比较沉稳；{{yzjkxx.data_8cd.data3}}位基本没有冲动性行为，做事沉稳，精确性高。</p>
        <img
          :src="yzjkxx.data_8cd.base64"
          alt=""
        >

        <p>总分能体现一个人的心理健康情况。 如下图中，测试结果显示：{{yzjkxx.data_zf.data1}}位心理健康状况不佳；
          {{yzjkxx.data_zf.data2}}位心理健康处于亚健康状态；{{yzjkxx.data_zf.data3}}位心理健康状况良好。</p>
        <img
          :src="yzjkxx.data_zf.base64"
          alt=""
        >

        <h3>三、总结与分析 </h3>
        <p>参加心理健康测评的人员共{{jcxx.sum}}人。根据测评数据统计结果发现，{{jcxx.jkDataSum|percentage(jcxx.sum)}}的人目前处于心理健康水平，
          {{(jcxx.bjkDataSum+jcxx.qqDataSum)|percentage(jcxx.sum)}}的人心理健康状况不佳。</p>
        <p>对于有心理问题倾向的人群，应该给予重点关注，有针对性的开展相关心理工作。除了对已有心理问题的人群给予相应的关注和采取措施外，
          处于心理亚健康状态的人群也同样需要重视。因为这部分人是产生心理问题的高危人群。目前他们可能都有一些心理困惑。
          虽不外显，但一旦出现负性事件，他们很可能出现一定程度的心理问题。 </p>

      </div>
      <div class="right">
        <p class="tit">—— 团体测评 ——</p>
        <p>
          发布人：
          <span>{{scaleInfo.publisherName}}</span>
        </p>
        <p>
          测评人数：
          <span>{{scaleInfo.planTotalPeople}}</span>
        </p>
        <div class="btn">
          <l-button
            value="删除"
            color="#3170FF"
            @click.native="deleteF()"
          ></l-button>
          <l-button
            value="导出"
            color="#FF500C"
            @click.native="exportWord1()"
          ></l-button>
          <l-button
            value="关闭"
            @click.native="close()"
          ></l-button>
        </div>
      </div>
    </div>
  </l-dialog>
</template>

<script>
require("../../../../utils/export/jquery.wordexport");
import lButton from "@/components/lButton.vue";
import lDialog from "@/components/lDialog.vue";
import exportWord from '@/utils/export/exportWord'
export default {
  components: {
    "l-button": lButton,
    "l-dialog": lDialog,
  },
  mixins: [ exportWord ],
  data () {
    return {
      bar: null,
      scaleInfo: {
        title: '',
        publisherName: '',
        planTotalPeople: '',
      },

      jcxx: {
        sum: 0, // 总人数
        sex_nan: 0, // 男
        sex_nv: 0, // 女
        age_qj: '0-100', // 年龄区间
        age_ave: '0', // 平均年龄
        age_bzc: '0', // 标准差
        base64_sex: '', // 男女比例图
        testSum: 100, // 测试题目数量
        yxDataSum: 0, // 结果有效
        wxDataSum: 0, // 结果无效
        jkDataSum: 0, // 健康人数
        qqDataSum: 0, // 欠佳
        bjkDataSum: 0, // 不健康人数
        base64_jk: '', // 健康状态图
      },

      yzjkxx: {
        data_1xx: {
          name: '学习焦虑',
          data1: 0, // 较高
          data2: 0, // 中等
          data3: 0, // 较低
          base64: '',
        }, // 学习焦虑
        data_2sj: {
          name: '对人焦虑',
          data1: 0,
          data2: 0,
          data3: 0,
          base64: '',
        }, // 对人焦虑
        data_3gd: {
          name: '孤独倾向',
          data1: 0,
          data2: 0,
          data3: 0,
          base64: '',
        }, // 孤独倾向
        data_4zz: {
          name: '自责倾向',
          data1: 0,
          data2: 0,
          data3: 0,
          base64: '',
        }, // 自责倾向
        data_5gm: {
          name: '过敏倾向',
          data1: 0,
          data2: 0,
          data3: 0,
          base64: '',
        }, // 过敏倾向
        data_6st: {
          name: '身体症状',
          data1: 0,
          data2: 0,
          data3: 0,
          base64: '',
        }, // 身体症状
        data_7kb: {
          name: '恐怖倾向',
          data1: 0,
          data2: 0,
          data3: 0,
          base64: '',
        }, // 恐怖倾向
        data_8cd: {
          name: '冲动倾向',
          data1: 0,
          data2: 0,
          data3: 0,
          base64: '',
        }, // 冲动倾向
        data_zf: {
          name: '总分',
          data1: 0,
          data2: 0,
          data3: 0,
          base64: '',
        }, // 总分
      },
      yzjkxxArr: [],

    };
  },
  props: {
    'show': {
      type: Boolean,
      default: false,
    },
    'publishInfoId': {
      type: [ String, Number ],
      default: '',
    },

  },
  filters: {
    percentage: function (val, sum) {
      if (!val || !sum) return '0%'
      val = +((val / sum) * 100).toFixed(2)
      return val + '%'
    }
  },
  computed: {
  },
  mounted () {
    this.bar = this.echarts.init(this.$refs.bar);
    window.addEventListener("resize", function () {
      this.bar.resize();
    });
  },
  watch: {
    show (val) {
      if (val) {
        this.getData()
      }
    },
    // publishInfoId () {
    //   this.getData()
    // },
  },
  methods: {
    async getData () {
      this.$refs.minBox.scrollTop = 0

      let { data } = await this.$post("api/test/getTMinShoolInfoId", {
        publishInfoId: this.publishInfoId,
      });
      console.log(data);
      
      let scaleData = data.data
      this.scaleInfo = {
        title: scaleData.Info.title,
        publisherName: scaleData.Info.publisherName,
        planTotalPeople: scaleData.Info.planTotalPeople.total,
      }

      this.jcxx.sum = scaleData.Info.planTotalPeople.total // 总人数
      this.jcxx.sex_nan = scaleData.Info.planTotalPeople.sex.nan // 男
      this.jcxx.sex_nv = scaleData.Info.planTotalPeople.sex.nv // 女
      this.jcxx.age_qj = scaleData.Info.planTotalPeople.age.min + '-' + scaleData.Info.planTotalPeople.age.max // 年龄区间
      this.jcxx.age_ave = scaleData.Info.planTotalPeople.age.average // 平均年龄
      this.jcxx.age_bzc = scaleData.Info.planTotalPeople.age.Standard // 标准差
      this.jcxx.testSum = scaleData.Info.testSum || this.jcxx.testSum // 测试题目数量
      this.jcxx.yxDataSum = scaleData.Info.valid.data1 // 结果有效
      this.jcxx.wxDataSum = scaleData.Info.valid.data2 // 结果无效
      this.jcxx.jkDataSum = scaleData.Info.healthy.data1 // 健康人数
      this.jcxx.qqDataSum = scaleData.Info.healthy.data2 // 欠佳
      this.jcxx.bjkDataSum = scaleData.Info.healthy.data3 // 不健康人数

      let nameMap = {
        'one': 'data_1xx', // 学习焦虑
        'two': 'data_2sj', // 对人焦虑
        'three': 'data_3gd', // 孤独倾向
        'foru': 'data_4zz', // 自责倾向
        'five': 'data_5gm', // 过敏倾向
        'six': 'data_6st', // 身体症状
        'seve': 'data_7kb', // 恐怖倾向
        'eight': 'data_8cd', // 冲动倾向
        'nine': 'data_zf', // 总分
      }
      for (let key in scaleData.list) {
        if (key in nameMap) {
          let obj = this.yzjkxx[nameMap[key]],
            dataItem = scaleData.list[key]
          obj.data1 = dataItem.high
          obj.data2 = dataItem.in
          obj.data3 = dataItem.low
        }
      }

      let yzjkxxArr = []
      for (let key in this.yzjkxx) {
        yzjkxxArr.push(this.yzjkxx[key])
      }
      this.yzjkxxArr = yzjkxxArr

      this.handEcharts()
    },
    //echarts
    handEcharts () {
      this.handEcharts_1()
      this.handEcharts_2()
      this.handEcharts_3()
    },
    handEcharts_1 () {
      let option = {
        animation: false,
        title: {
          text: '参试人员性别统计分布表',
          left: 'center',
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          top: 'bottom',
        },
        label: {
          formatter: '{b}\n{center|{d}%}',
          fontSize: 14,
          rich: {
            center: {
              lineHeight: 22,
              align: 'center'
            },
          }
        },
        series: [
          {
            name: '参试人员性别统计分布表',
            type: 'pie',
            radius: '60%',
            data: [
              { value: this.jcxx.sex_nan, name: '男' },
              { value: this.jcxx.sex_nv, name: '女' },
            ],
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      this.bar.setOption(option, { notMerge: true, });
      var opts = {
        //type: "jpeg", // 导出的格式，可选 png, jpeg
        pixelRatio: 1, // 导出的图片分辨率比例，默认为 1。
        //backgroundColor: "#fff", // 导出的图片背景色，默认使用 option 里的 backgroundColor
      };
      this.jcxx.base64_sex = this.bar.getDataURL(opts); //拿到base64 地址
    },
    handEcharts_2 () {
      let option = {
        animation: false,
        title: {
          text: '参试人员心理健康状态分布表',
          left: 'center',
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          top: 'bottom',
        },
        label: {
          formatter: '{b}\n{center|{d}%}',
          fontSize: 14,
          rich: {
            center: {
              lineHeight: 22,
              align: 'center'
            },
          }
        },
        series: [
          {
            name: '参试人员心理健康状态分布表',
            type: 'pie',
            radius: '60%',
            data: [
              { value: this.jcxx.jkDataSum, name: '健康', },
              { value: this.jcxx.qqDataSum, name: '欠佳', },
              { value: this.jcxx.bjkDataSum, name: '不健康', itemStyle: { color: '#fac858' }, },
            ],
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      this.bar.setOption(option, { notMerge: true, });
      var opts = {
        //type: "jpeg", // 导出的格式，可选 png, jpeg
        pixelRatio: 1, // 导出的图片分辨率比例，默认为 1。
        //backgroundColor: "#fff", // 导出的图片背景色，默认使用 option 里的 backgroundColor
      };
      this.jcxx.base64_jk = this.bar.getDataURL(opts); //拿到base64 地址
    },
    handEcharts_3 () {
      let hhFoo = (obj) => {
        let option = {
          animation: false,
          title: {
            text: obj.name,
            left: 'center',
          },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            top: 'bottom',
          },
          label: {
            formatter: '{b}\n{center|{d}%}',
            fontSize: 14,
            rich: {
              center: {
                lineHeight: 22,
                align: 'center'
              },
            }
          },
          series: [
            {
              name: obj.name,
              type: 'pie',
              radius: '60%',
              data: [
                { value: obj.data3, name: '较低' },
                { value: obj.data2, name: '中等' },
                { value: obj.data1, name: '较高' },
              ],
            }
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        this.bar.setOption(option, { notMerge: true, });
        var opts = {
          //type: "jpeg", // 导出的格式，可选 png, jpeg
          pixelRatio: 1, // 导出的图片分辨率比例，默认为 1。
          //backgroundColor: "#fff", // 导出的图片背景色，默认使用 option 里的 backgroundColor
        };
        obj.base64 = this.bar.getDataURL(opts); //拿到base64 地址
      }

      // yzjkxx: {
      //   data_1xx: {
      //     name: '学习焦虑',
      //     data1: 10, // 较高
      //     data2: 20, // 中等
      //     data3: 30, // 较低
      //     base64: '',
      //   }, // 学习焦虑
      for (let key in this.yzjkxx) {
        let item = this.yzjkxx[key]
        hhFoo(item)
      }

    },
    //导出
    exportWord1 () {
      let data = {
        title: this.scaleInfo.title,
        yzjkxxArr: [],
      }
      for(let key in this.jcxx) {
        data['jcxx.'+key] = this.jcxx[key]
      }
      data['jcxx.sex_nan_bfb'] = percentage(this.jcxx.sex_nan, this.jcxx.sum)
      data['jcxx.sex_nv_bfb'] = percentage(this.jcxx.sex_nv, this.jcxx.sum)
      data['jcxx.yxDataSum_bfb'] = percentage(this.jcxx.yxDataSum, (this.jcxx.yxDataSum+this.jcxx.wxDataSum))
      data['jcxx.wxDataSum_bfb'] = percentage(this.jcxx.wxDataSum, (this.jcxx.yxDataSum+this.jcxx.wxDataSum))
      data['jcxx.jkDataSum_bfb'] = percentage(this.jcxx.jkDataSum, (this.jcxx.jkDataSum+this.jcxx.qqDataSum+this.jcxx.bjkDataSum))
      data['jcxx.qqDataSum_bfb'] = percentage(this.jcxx.qqDataSum, (this.jcxx.jkDataSum+this.jcxx.qqDataSum+this.jcxx.bjkDataSum))
      data['jcxx.bjkDataSum_bfb'] = percentage(this.jcxx.bjkDataSum, (this.jcxx.jkDataSum+this.jcxx.qqDataSum+this.jcxx.bjkDataSum))
      data['jcxx.jkDataSum_e_bfb'] = percentage(this.jcxx.jkDataSum, (this.jcxx.jkDataSum+this.jcxx.qqDataSum+this.jcxx.bjkDataSum))
      data['jcxx.bjkDataSum_e_bfb'] = percentage((this.jcxx.bjkDataSum + this.jcxx.qqDataSum), (this.jcxx.jkDataSum+this.jcxx.qqDataSum+this.jcxx.bjkDataSum))
      
      for(let key1 in this.yzjkxx) {
        for (let key2 in this.yzjkxx[key1]) {
          data['yzjkxx.'+key1+'.'+key2] = this.yzjkxx[key1][key2]
        }
      }
      for(let item of this.yzjkxxArr) {
        data.yzjkxxArr.push(Object.assign({
          data1_bfb: percentage(item.data1, item.data1 + item.data2 + item.data3),
          data2_bfb: percentage(item.data2, item.data1 + item.data2 + item.data3),
          data3_bfb: percentage(item.data3, item.data1 + item.data2 + item.data3),
        }, item))
      }
      console.log(data)
      this.exportWord('docxTemplate/teamMHT.docx', this.scaleInfo.title, data)

      function percentage(val, sum) {
        if (!val || !sum) return '0%'
        val = +((val / sum) * 100).toFixed(2)
        return val + '%'
      }
    },
    // exportWord1 () {
    //   let _this = this;
    //   let pre = this.$refs.minBox.outerHTML;
    //   console.log(pre)
    //   let html = `<div>
    //             <h2 style="text-align:center">《${this.scaleInfo.title}》</h2>
    //             <div style="display:flex">
    //                 <span>发布人：${this.scaleInfo.publisherName}</span>&nbsp;&nbsp; <span>测评人数：${this.scaleInfo.planTotalPeople}</span><br>
    //                 <h4>测试结果</h4>
    //                 ${pre}
    //             </div></div>`;
    //   setTimeout(function () {
    //     $(html).wordExport(_this.scaleInfo.title, []);
    //   }, 1000);
    // },
    deleteF () {
      this.$emit("deleteF")
    },
    close () {
      this.$emit("update:show", false);
    },
  },
};
</script>

<style lang='less' scoped>
.teamMHT /deep/.dialog {
  width: 1000px;
  height: 750px;
}
.tBox {
  display: flex;
  height: 100%;
  background: #fff;
}
.left {
  width: 719px;
  overflow-y: auto;
  border-right: 1px solid #f0f0f0;
  padding: 20px 50px;
  box-sizing: border-box;

  h3 {
    font-size: 24px;
    color: #1298e6;
    padding: 8px 0;
    border-bottom: 1px solid #666;
    margin: 16px 0;
  }
  h4 {
    font-size: 18px;
    color: #07935d;
    margin: 16px 0;
  }
  p {
    text-indent: 2em;
    font-size: 16px;
    line-height: 1.7em;
    margin: 8px 0;
    word-break: break-all;
    text-align: justify;
  }
  img {
    max-width: 100%;
    min-height: 300px;
    margin: 8px 0;
  }

  table {
    width: 100%;
    color: #333;
    font-size: 16px;
    text-align: center;
    border: 1px solid #666;
    margin: 8px 0;
    td {
      height: 40px;
      border: 1px solid #666;
    }
  }
}
.right {
  font-size: 14px;
  width: 280px;
  box-sizing: border-box;
  .tit {
    margin: 39px 0 29px 0;
    text-align: center;
    color: #5f5f5f;
  }
  p {
    margin-left: 30px;
    margin-bottom: 25px;
  }
  span {
    color: #555;
  }
  .btn {
    position: absolute;
    height: 40px;
    line-height: 40px;
    bottom: 50px;
    right: 20px;
    button {
      width: 70px;
      margin: 0 5px;
    }
  }
}
</style>